module.exports = function(options) {

    return {
        ...options,

        // Overwrite options
        language: 'nl',

        // Add styles
        stylesSet: [
            { name: 'Normal', element: 'span', attributes: { 'class': '' } },
        ],

        height: 750

    };

};
